import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@vds/buttons";
import { Loader } from "@vds/loaders";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import NewHeader from "../../layouts/NewHeader";
import CircleCheck from "../../assets/circle-check-green.svg"
import {setuppassword} from "../../global/utility/Utils";
import { validatePassword as checkPasswordPolicy, PASSWORD_RULES } from "../../global/constants/passwordPolicy";

const SetupPassword = (props) => {
  const location = useLocation();

  const [form, setForm] = useState({
    fields: {
      password: {
        value: "",
        error: null,
        isDirty: false,
      },
      confirmpassword: {
        value: "",
        error: null,
        isDirty: false
      }
    },
    isSubmitted: false,
    isPasswordFieldVisible: false,
    showPassword: false,
  });
  const [left, setLeft] = useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const loading = useSelector((state) => state.auth.loading);
  const error = useSelector((state) => state.auth.error);
  const [emailval, setEmailVal] = useState('');
  const [bearerToken, setbearerToken] = useState();
  const [tokenmsg, setTokenMsg] = useState(false);
  const [responsemsg, setResponseMsg] = useState(false);
  
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const token = query.get('token');
    let bearer_value =query.get('bearerToken');
    if (token) {
        try {
          const decodedEmail = decodeURIComponent(token);
          setbearerToken(bearer_value)
          if (decodedEmail) {
            setEmailVal(decodedEmail)
        } else {
            setTokenMsg(true)
        }
        } catch (err) {
            setTokenMsg(true)
        }
    }
}, [location]);

  useEffect(() => {
    if (error) {
      setForm((prev) => ({
        ...prev,
        fields: {
          ...prev.fields,
          password: { ...prev.fields.password, value: "", error: null, isDirty: false },
        },
      }));
    }
  }, [error]);
  const togglePasswordVisibility = () => {
    setForm((prev) => ({
      ...prev,
      showPassword: !prev.showPassword,
    }));
  };
  const validateConfirmPassword = (password, confirmPassword) => {
    if (confirmPassword === "") {
        setForm((prev) => ({
            ...prev,
            fields: { ...prev.fields, confirmpassword: { value: confirmPassword, error: "Confirm Password is required", isDirty: true } }
        }));
    } else if (password !== confirmPassword) {
        setForm((prev) => ({
            ...prev,
            fields: { ...prev.fields, confirmpassword: { value: confirmPassword, error: "Passwords do not match", isDirty: true } }
        }));
    } else {
        setForm((prev) => ({
            ...prev,
            fields: { ...prev.fields, confirmpassword: { value: confirmPassword, error: null, isDirty: true } }
        }));
    }
};
  const validatePassword = (password) => {
    if (password === "") {
      setForm((prev) => ({
        ...prev,
        fields: {
          ...prev.fields,
          password: {
            value: password,
            error: "Enter password",
            isDirty: true,
          },
        },
      }));
    } else if (!checkPasswordPolicy(password)) {
      setForm((prev) => ({
        ...prev,
        fields: {
          ...prev.fields,
          password: {
            value: password,
            error: "Password does not meet the requirements below",
            isDirty: true,
          },
        },
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        fields: {
          ...prev.fields,
          password: { value: password, error: null, isDirty: true },
        },
      }));
    }
  };
  const handlePasswordChange = (e) => {
    const { id, value } = e.target;
    if (id === 'password') {
      validatePassword(value);
      validateConfirmPassword(value, form.fields.confirmpassword.value);
  } else if (id === 'confirmpassword') {
      validateConfirmPassword(form.fields.password.value, value);
  } 
  };
  const onSubmitVal = async () => {
    validatePassword(form.fields.password.value);
    validateConfirmPassword(form.fields.password.value, form.fields.confirmpassword.value);
    setForm((prev) => ({ ...prev, isSubmitted: true }));
    if (form.fields.password.isDirty && form.fields.password.error === null && form.fields.confirmpassword.isDirty && form.fields.confirmpassword.error === null) {
      const selectedAccount = {
        bearerToken: bearerToken,
        password: form.fields.password.value.trim(),
      };
     const response = await setuppassword(selectedAccount);
      if(response==204){
        setResponseMsg(true)
      }else{
       setTokenMsg(true)
      }
    }
  };
  const onLoginVal = async () => {
    navigate("/login");
  };
  return (
    <>
      <NewHeader left={left} setLeft={setLeft} navmenu={"hide"} />
      <div style={{ height: "calc(94vh - 50px)" }}>
        <Loader active={loading} />
        <br />
        <br />
        <Grid2 container marginTop={1} marginBottom={2} spacing={1} columns={{ xs: 12 }}>
          <Grid2 item xs={2} sm={2} md={3} lg={4} direction="row"></Grid2>
          <Grid2 item xs={12} sm={8} md={6} lg={4} direction="row">
            <div className="login-heading-container">
              <div className="login_heading">
              <p style={{ display: responsemsg===true?"none":"block"}}>
                <h1 className="setup_heading_h1">Set Up Password</h1>
                {tokenmsg && (
                      <div className="alert-box">
                        <div className="text-container_val">
                          <h4 className="alert-title">    <span className="alert-icon"> <i className="bi bi-exclamation-diamond"></i></span>Invalid setup token</h4>
                          <p className="alert-description">It may have expired or may already have been used.</p>
                        </div>
                      </div>
                 )}
                <div className="mb-3">
                  <label className="input-label-user" htmlFor="email">Email</label>
                  <div className="input-container">
                    <input
                      id="email"
                      type="text"
                      label="Email address"
                      className={`form-control login-form-control`}
                      value={emailval}
                      readOnly
                      style={{backgroundColor:"red !important"}}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="input-label-user" htmlFor="password">New password</label>
                  <div className="input-container">
                    <input
                      id="password"
                      label="Password"
                      type={form.showPassword ? "text" : "password"}
                      className={`form-control login-form-control ${form.isSubmitted &&
                        form.fields.password.isDirty &&
                        form.fields.password.error &&
                        "input-invalid-border-background-color"
                        } ${form.isSubmitted &&
                        form.fields.password.isDirty &&
                        !form.fields.password.error &&
                        "input-valid-border-background-color"
                        }`}
                      value={form.fields.password.value}
                      onChange={handlePasswordChange}
                      onKeyUp={(e) => e.key === "Enter" ? onSubmitVal() : null}
                    />
                    <span
                      className={"login-show-password"}
                      onClick={togglePasswordVisibility}
                      style={{
                        textDecoration: "underline",
                      }}
                    >
                      {form.showPassword ? "Hide" : "Show"}
                    </span>
                   
                    {form.isSubmitted && form.fields.password.isDirty && form.fields.password.error && (
                      <i className="bi bi-exclamation-diamond input-icon-failure"></i>
                    )}
                    {form.isSubmitted && form.fields.password.isDirty && !form.fields.password.error && (
                      <i className="bi-check-lg input-icon-success"></i>
                    )}
                  </div>
                  {form.isSubmitted && form.fields.password.isDirty && form.fields.password.error && (
                    <span className="input-label-user">{form.fields.password.error}</span>
                  )}
                  <ul className="setup_info" style={{ paddingLeft: "1.2rem", margin: "4px 0" }}>
                    {PASSWORD_RULES.map((rule, index) => (
                      <li key={index} style={{ marginBottom: "2px" }}>{rule}</li>
                    ))}
                  </ul>
                </div>
                <div className="mb-3">
                  <label className="input-label-user" htmlFor="confirmpassword">Confirm Password</label>
                  <div className="input-container">
                    <input
                      id="confirmpassword"
                      label="confirmpassword"
                      type={form.showPassword ? "text" : "password"}
                      className={`form-control login-form-control ${form.isSubmitted &&
                        form.fields.confirmpassword.isDirty &&
                        form.fields.confirmpassword.error &&
                        "input-invalid-border-background-color"
                        } ${form.isSubmitted &&
                        form.fields.confirmpassword.isDirty &&
                        !form.fields.confirmpassword.error &&
                        "input-valid-border-background-color"
                        }`}
                      value={form.fields.confirmpassword.value}
                      onChange={handlePasswordChange}
                      onKeyUp={(e) => e.key === "Enter" ? onSubmitVal() : null}
                    />
                    <span
                      className={"login-show-password"}
                      onClick={togglePasswordVisibility}
                      style={{
                        textDecoration: "underline",
                      }}
                    >
                      {form.showPassword ? "Hide" : "Show"}
                    </span>
                    {form.isSubmitted && form.fields.confirmpassword.isDirty && form.fields.confirmpassword.error && (
                      <i className="bi bi-exclamation-diamond input-icon-failure"></i>
                    )}
                    {form.isSubmitted && form.fields.confirmpassword.isDirty && !form.fields.confirmpassword.error && (
                      <i className="bi-check-lg input-icon-success"></i>
                    )}
                  </div>
                  {form.isSubmitted && form.fields.confirmpassword.isDirty && form.fields.confirmpassword.error && (
                    <span className="input-label-user">{form.fields.confirmpassword.error}</span>
                  )}
                </div>
                </p>
                <div className="mb-3" style={{textAlign:"center", display: responsemsg===true?"block":"none"}}>
                      <img src={CircleCheck} className="icon" alt="circle-check"  style={{marginBottom:"5%"}}/>
                      <p className="setup_msg_success">Password Created</p>
                      <p className="setup_msg" >Your password has been created successfully.</p>
                      </div>
                <Grid2 item xs={12} style={{ display: responsemsg===true?"none":"block" }}>
                  <Button
                    type="primary"
                    className="login-pageButton"
                    fullWidth
                    onClick={onSubmitVal}
                    disabled={loading}
                  >
                    Confirm
                  </Button>
                </Grid2>
                <Grid2 item xs={12} style={{ display: responsemsg===true?"block":"none" }}>
                  <Button
                    type="primary"
                    className="login-pageButton"
                    fullWidth
                    onClick={onLoginVal}
                    disabled={loading}
                  >
                    Login
                  </Button>
                </Grid2>
              </div>
            </div>
          </Grid2>
        </Grid2>
      </div>
    </>
  );
};

export default SetupPassword;
